import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import filter24 from 'images/icons/filter-24.svg';
import filterFilled24 from 'images/icons/filter-filled-24.svg';
import React from 'react';
import { Reference } from 'react-popper';

interface Props {
  onFilterClick: () => void;
  filterApplied: boolean;
}

const FilterButton: React.FC<Props> = (props: Props) => {
  const { onFilterClick, filterApplied } = props;
  const { translate } = useTranslator(['buttons', 'filters']);
  const filterIcon = filterApplied ? filterFilled24 : filter24;

  return (
    <Reference>
      {({ ref }): React.ReactNode => (
        <div ref={ref} className="hs2 flex items-center">
          <Button
            id="filter-list-button"
            className="row items-center justify-between mr4 btn-link btn-sm"
            onClick={onFilterClick}
            variant="tertiary"
          >
            <img
              className="wrem-1p5 primary-blue"
              src={filterIcon}
              alt="filter filled icon"
            />
            {translate('buttons:filter')}
          </Button>
        </div>
      )}
    </Reference>
  );
};

export default FilterButton;
